module.exports = __webpack_public_path__ + "img/petronas-gmap - Copy.256d2b9c.png";